/**
 * Full-screen loading state. After a short delay it reassures the user that a
 * cold-started backend (Function App / Azure SQL serverless waking from idle)
 * may take a few seconds — so a slow first load never looks broken or stuck.
 */
import { useEffect, useState } from 'react';
import { useI18n } from '../i18n';
import { Spinner } from './ui';

export function LoadingScreen({ label }: { label?: string }) {
  const { t } = useI18n();
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setSlow(true), 3500);
    return () => clearTimeout(id);
  }, []);

  const text = label ?? t.common.loading;

  return (
    <main className="auth-screen">
      <div className="card auth-card">
        <Spinner label={text} />
        <p className="lead" style={{ margin: '12px 0 0' }}>
          {text}
        </p>
        {slow ? (
          <p className="text-xs muted" style={{ marginTop: 12 }}>
            {t.auth.warmingUp}
          </p>
        ) : null}
      </div>
    </main>
  );
}
